import { __exports as ErrorHandler } from "./index151.js";
var hasRequiredErrorHandler;
function requireErrorHandler() {
  if (hasRequiredErrorHandler) return ErrorHandler;
  hasRequiredErrorHandler = 1;
  Object.defineProperty(ErrorHandler, "__esModule", {
    value: true
  });
  var _createClass = /* @__PURE__ */ (function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  })();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var ErrorHandler$1 = (function() {
    function ErrorHandler2(api) {
      _classCallCheck(this, ErrorHandler2);
      this.api = api;
    }
    _createClass(ErrorHandler2, [{
      key: "handleCatch",
      value: function handleCatch(e) {
        if (e.name === "InvalidInputException") {
          if (this.api._options.valid !== this.api._defaults.valid) {
            this.api._options.valid(false);
          } else {
            throw e.message;
          }
        } else {
          throw e;
        }
        this.api.render = function() {
        };
      }
    }, {
      key: "wrapBarcodeCall",
      value: function wrapBarcodeCall(func) {
        try {
          var result = func.apply(void 0, arguments);
          this.api._options.valid(true);
          return result;
        } catch (e) {
          this.handleCatch(e);
          return this.api;
        }
      }
    }]);
    return ErrorHandler2;
  })();
  ErrorHandler.default = ErrorHandler$1;
  return ErrorHandler;
}
export {
  requireErrorHandler as __require
};
//# sourceMappingURL=index119.js.map
